import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import PrivacyWeb from 'components/privacy-web';

type Props = {
  data: Object,
};

const PrivacyWebPage = ({ data }: Props) => {
  const {
    privacyWebJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...privacyWebJson,
        menu: siteJson?.content,
        cookieConsent: cookieConsentJson,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <PrivacyWeb />
      </Layout>
    </Website>
  );
};

export default PrivacyWebPage;

export const query = graphql`
  query PrivacyWebPageQuery {
    privacyWebJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
        text
      }
      intro {
        title
        greece {
          title
          data {
            id
            label
            details
          }
        }
      }
      statements {
        tabs {
          id
          label
          title
          text
          list {
            items
          }
        }
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
